import { apiFetch } from "./client";
import type {
  AgentCatalogItem,
  AgentRun,
  AgentRunConversation,
  AgentRunDetail,
} from "./types";

/** Recent agent runs (scheduled + triggered) for the Agents page list view. */
export function listAgentRuns(limit = 100) {
  return apiFetch<AgentRun[]>(`/api/v1/dashboard/agent-runs?limit=${limit}`);
}

/** Registered agents — used by the Catalog page. */
export function listAgents() {
  return apiFetch<AgentCatalogItem[]>("/api/v1/agents");
}

/** Full detail (row + outputs + logs) for the Agents drawer. */
export function getAgentRunDetail(runUuid: string) {
  return apiFetch<AgentRunDetail>(`/api/v1/agents/runs/${runUuid}/detail`);
}

/** Chat thread for the run, if any. */
export function getAgentRunConversation(runUuid: string) {
  return apiFetch<AgentRunConversation>(`/api/v1/agents/runs/${runUuid}/conversation`);
}

/** Manually fire an agent. Body shape mirrors backend TriggerBody. */
export function triggerAgent(name: string, body: Record<string, unknown> = {}) {
  return apiFetch<unknown>(`/api/v1/agents/${encodeURIComponent(name)}/trigger`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
